import React, { useState } from 'react'

const MAX_LENGTH = 30

interface TruncatedTextProps {
  previewText: string
  htmlText: string
  title?: string
}

export default function TruncatedText({
  previewText,
  htmlText,
  title,
}: TruncatedTextProps) {
  const hideExpected = htmlText.length > MAX_LENGTH
  const [hidden, setHidden] = useState(hideExpected)

  return (
    <article>
      <div className='inner-row'>
        {title && <h2 className='h1'>{title}</h2>}
        <div
          dangerouslySetInnerHTML={{
            __html: hidden ? previewText : htmlText,
          }}
        />

        {hideExpected && (
          <a
            onClick={() => setHidden(!hidden)}
            className='mlc-btn mlc-btn-type-1'
          >
            {hidden ? 'Lire la suite' : 'Masquer le texte'}
          </a>
        )}
      </div>
    </article>
  )
}
